import { render, staticRenderFns } from "./ListInitialRecommendation.vue?vue&type=template&id=8c1043ce&scoped=true"
import script from "./ListInitialRecommendation.vue?vue&type=script&lang=js"
export * from "./ListInitialRecommendation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c1043ce",
  null
  
)

export default component.exports